/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const handleHeaderErrorMessages = (data) => ({
  type: actionTypes.HANDLE_HEADER_ERROR_MSG,
  errorMessagesInRedux: data,
});
export const handleFieldLevelErrMsg = (data) => ({
  type: actionTypes.HANDLE_FIELD_LEVE_ERROR_MSG,
  fieldLevelErros: data,
});
export const searchMailingRequestAction = (data) => {
  return {
    type: actionTypes.SEARCH_MAILING_REQUEST,
    payload: data,
  };
};

// ################ Rebate Program Code Dropdown ######################
export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};
export const getRebateProgramCode = (values) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};
// ################ Address Type Code Dropdown ######################
export const dispatchAllAddressTypeCode = (data) => {
  return {
    type: actionTypes.GET_ALL_ADDRESS_TYPE_CODE,
    payload: data,
  };
};
export const getAddressTypeCode = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.ADDRESS_TYPE_DD}`)
    .then((response) => {
      return dispatch(dispatchAllAddressTypeCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllAddressTypeCode(response.date));
    });
};
// ################ End of Rebate Program Code Dropdown ######################

// ################ Get Manufacturer Details Code Dropdown ######################
export const dispatchAllManufacturerRequestMailing = (data) => {
  return {
    type: actionTypes.GET_REQUEST_MAILING_MANUFACTURER_DETAILS,
    getManufacturerDetailsRequest: data,
  };
};
export const getManufacturerRequestMailing = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.MANUFACTURER_DETAILS_REQUEST_MAILING}`, values)
    .then((response) => {
      return dispatch(dispatchAllManufacturerRequestMailing(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllManufacturerRequestMailing(response.data));
    });
};
// ################ Get Manufacturer Details Code Dropdown ######################
// ################ Get count for Manufacturer Label ######################
export const dispatcCountAllMfgLabels = (data) => {
  return {
    type: actionTypes.GET_COUNT_MGF_LABEL_REQUEST_LABEL,
    getCountOfAllMfgLabelsReq: data,
  };
};
export const getCountOfAllMfgLabelsReqLabel = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.REQUEST_MAILING_COUNT_MFG_LABEL}`, values)
    .then((response) => {
      return dispatch(dispatcCountAllMfgLabels(response.data));
    })
    .catch((response) => {
      dispatch(dispatcCountAllMfgLabels(response.data));
    });
};
// ################ Get count for Manufacturer Label ######################
// ################ Get count for Filtered Manufacturer Label ######################
export const dispatchCountAllFilteredMfgLabels = (data) => {
  return {
    type: actionTypes.GET_COUNT_FILTERED_MGF_LABEL_REQUEST_LABEL,
    getCountOfAllFilteredMfgLabelsReq: data,
  };
};
export const getCountOfAllFilteredMfgLabelsReqLabel =
  (values) => (dispatch) => {
    return axios
      .post(
        `${serviceEndPoint.REQUEST_MAILING_COUNT_FILTERED_MFG_LABEL}`,
        values
      )
      .then((response) => {
        return dispatch(dispatchCountAllFilteredMfgLabels(response.data));
      })
      .catch((response) => {
        dispatch(dispatchCountAllFilteredMfgLabels(response.data));
      });
  };
// ################ Get count for Filtered Manufacturer Label ######################
// ################ Get PDF for Manufacturer Label ######################
export const dispatchAllMfgLabels = (data) => {
  return {
    type: actionTypes.GET_MGF_LABEL_REQUEST_LABEL,
    getAllMfgLabelsReq: data,
  };
};
export const getAllMfgLabelsReqLabel = (values) => (dispatch) => {
  const url =
    values.url === 'allMfg'
      ? `${serviceEndPoint.REQUEST_MAILING_PDF_MFG_LABEL}`
      : `${serviceEndPoint.REQUEST_MAILING_PDF_FILTERED_MFG_LABEL}`;
  const req = values.req;
  return axios
    .post(url, req, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return dispatch(dispatchAllMfgLabels(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllMfgLabels(response.data));
    });
};
// ################ Get count for Manufacturer Label ######################

// Clear redux store
export const clearReduxMailingRequest = () => (dispatch) => {
  dispatch(dispatchAllAddressTypeCode([]));
  dispatch(dispatchAllRebateProgramCode([]));
};
